<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('services')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :page_length="50"
      resource_url="/odometer/service/datatables"
    ></generic-table>
  </div>

  <service-modal ref="service_modal" @updated="refresh" />
  <finalize-service-modal ref="finalize_service_modal" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date,
  format_currency,
  api_host,
} from "@/utils";
import ServiceModal from "./service_modal/Index.vue";
import FinalizeServiceModal from "./finalize_service_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "ServiceDatatable",
  components: {
    GenericTable,
    ServiceModal,
    VLazyImage,
    FinalizeServiceModal,
  },
  props: {
    // module_settings: {
    //   type: Object,
    //   required: true,
    // },
  },
  data() {
    let v = this;
    return {
      api_host,
      extra_buttons: [
        {
          text: v.$t("add"),
          icon: "fa fa-plus",
          class: "is-secondary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("reception date"),
          // width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date(row.reception_date);
          },
        },
        {
          title: v.$t("customer"),
          name: "customer",
          // width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            let r = `<div class="title is-6">${row.customer_name}</div>`;
            if (row.email)
              r += `<div class="subtitle is-7 mb-0">
                <span class="icon is-small">
                  <i class="fa fa-envelope"></i>
                </span>
                ${row.email}
            </div>`;
            if (row.phone_number)
              r += `<div class="subtitle is-7">
                <span class="icon is-small">
                  <i class="fa fa-phone"></i>
                </span>
                ${row.phone_number}
            </div>`;
            return r;
          },
        },
        {
          title: v.$t("vehicle"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            let r = `<div class="title is-6">${
              row.brand
            }</div><div class="subtitle is-7 mb-0">${row.line || ""} ${
              row.year || ""
            }</div>`;
            if (row.mileage)
              r += `<div class="subtitle is-7">
                <span class="icon is-small">
                  <i class="fa fa-tachometer"></i>
                </span>
                ${row.mileage}
            </div>`;
            return r;
          },
        },
        {
          title: v.$t("final"),
          searchable: false,
          data: (row) => {
            if (row.settings && row.settings.finalize) {
              let r = `<div class="title is-6">${format_currency(
                row.settings.finalize.final_amount
              )}</div><div class="subtitle is-7 mb-0"><span class="icon is-small">
                  <i class="fa fa-comment"></i>
                </span>${row.settings.finalize.final_comments || ""}</div>`;
              return r;
            } else return "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.service_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("finalize service"),
                icon: "fa fa-flag-checkered",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.finalize_service_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete service?"),
                    v,
                    () => {
                      del("/odometer/service", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.service_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    // edit(item) {
    //   let v = this;
    //   v.$refs.team_modal.edit_modal(item.uuid);
    // },
    // remove(item) {
    //   let v = this;
    //   confirm_deletion_dialog(
    //     v.$t("are you sure to delete representation?"),
    //     v,
    //     () => {
    //       del("/museum/representation", { uuid: item.uuid })
    //         .then(() => {
    //           v.refresh();
    //         })
    //         .catch((error) => {
    //           error_message(error);
    //         });
    //     }
    //   );
    // },
  },
  mounted() {
    let v = this;
    v.refresh();
    // window.new_product = () => {
    //   v.create();
    // };
  },
};
</script>

<style></style>
